export default __webpack_public_path__ + "static/media/plyr.9c6519bf.jpg";